export const capitalizeString = (text: string): string =>
  text && text.charAt(0).toUpperCase() + text.slice(1);
